import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  isEnglishRoute,
  getEquivalentRoute,
  setStoredLanguage,
} from '../lib/i18n';

export default function LanguageSwitcher({ variant = 'desktop' }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isEn = isEnglishRoute(location.pathname);

  const handleSwitch = (targetLang) => {
    if ((targetLang === 'en' && isEn) || (targetLang === 'da' && !isEn)) {
      return;
    }
    setStoredLanguage(targetLang);
    const targetRoute = getEquivalentRoute(location.pathname, targetLang);
    navigate(targetRoute);
  };

  if (variant === 'mobile') {
    return (
      <div className="flex items-center gap-1 bg-stone-100 p-1 rounded-md border border-stone-200">
        <button
          type="button"
          onClick={() => handleSwitch('da')}
          className={`flex-1 py-1.5 px-3 text-xs font-bold rounded transition-all cursor-pointer flex items-center justify-center gap-1.5 ${
            !isEn
              ? 'bg-[#006368] text-white shadow-2xs'
              : 'text-stone-600 hover:text-stone-900 hover:bg-stone-200/60'
          }`}
          aria-label="Skift til Dansk"
          aria-pressed={!isEn}
        >
          <span>DA</span>
          <span className="text-[10px] font-normal opacity-85">Dansk</span>
        </button>
        <button
          type="button"
          onClick={() => handleSwitch('en')}
          className={`flex-1 py-1.5 px-3 text-xs font-bold rounded transition-all cursor-pointer flex items-center justify-center gap-1.5 ${
            isEn
              ? 'bg-[#006368] text-white shadow-2xs'
              : 'text-stone-600 hover:text-stone-900 hover:bg-stone-200/60'
          }`}
          aria-label="Switch to English"
          aria-pressed={isEn}
        >
          <span>EN</span>
          <span className="text-[10px] font-normal opacity-85">English</span>
        </button>
      </div>
    );
  }

  // Desktop variant: compact, unobtrusive pill switcher
  return (
    <div
      className="inline-flex items-center bg-stone-100 rounded-full p-0.5 border border-stone-200 text-xs font-bold shrink-0"
      role="group"
      aria-label="Language selection"
    >
      <button
        type="button"
        onClick={() => handleSwitch('da')}
        className={`px-2.5 py-1 rounded-full transition-all cursor-pointer ${
          !isEn
            ? 'bg-[#006368] text-white shadow-2xs'
            : 'text-stone-600 hover:text-stone-900'
        }`}
        aria-label="Dansk version"
        aria-pressed={!isEn}
      >
        DA
      </button>
      <span className="text-stone-300 text-[10px] select-none">|</span>
      <button
        type="button"
        onClick={() => handleSwitch('en')}
        className={`px-2.5 py-1 rounded-full transition-all cursor-pointer ${
          isEn
            ? 'bg-[#006368] text-white shadow-2xs'
            : 'text-stone-600 hover:text-stone-900'
        }`}
        aria-label="English version"
        aria-pressed={isEn}
      >
        EN
      </button>
    </div>
  );
}
